import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';
import { PurchaseMode } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import * as React from 'react';
import { Box } from '@wix/design-system';
import { LastDaySaleBannerContent } from './LastDaySaleBannerContent';
import s from './SaleBanner.scss';
import { SaleBannerContent } from './SaleBannerContent';

interface SaleBannerProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const SaleBannerComp: React.FunctionComponent<SaleBannerProps> = ({
  rootStore,
}) => {
  const { purchaseMode } = rootStore.appStore.appContext;
  const { theme } = usePageModeContext();

  return (
    <Box className={classNames(s.saleStrip, theme)} dataHook='sale-banner'>
      <Box
        padding='13px 36px'
        verticalAlign='middle'
        align='center'
        width='100%'
        textAlign='center'
      >
        {purchaseMode === PurchaseMode.LAST_DAY_SALE ? (
          <LastDaySaleBannerContent />
        ) : (
          <SaleBannerContent />
        )}
      </Box>
    </Box>
  );
};

export const SaleBanner = withInjectedRootStore(
  withExperiments(SaleBannerComp),
);
